import React from 'react';

const RenderIfTrue = (props) => {
  let jsx = null;
  if (props.condition === true) {
    jsx = props.children;
  } else {
    if (props.else) {
      jsx = props.else;
    } 
  }
  return (
    <>
      {jsx}
    </>
  );
};

export default RenderIfTrue;